import LoginModal from '@components/loginModal';

import MarketingPolicyAgreeModal from '@components/events/eventChallenge/modalsWrap/marketingPolicyAgreeModal';
import MarketingPolicyCompleteModal from '@components/events/eventChallenge/modalsWrap/marketingPolicyCompleteModal';

export type ModalState = 'LOGIN' | 'MARKETING_POLICY_AGREE' | 'MARKETING_POLICY_COMPLETE' | null;

interface EventProfileApplyModalProps {
  modalState: ModalState;
  setModalState: (modalState: ModalState) => void;
}

const EventProfileApplyModal = ({ modalState, setModalState }: EventProfileApplyModalProps) => {
  const isVisible = (state: ModalState) => state === modalState;
  const closeModal = () => setModalState(null);

  return (
    <>
      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={isVisible('LOGIN')}
        onClose={closeModal}
      />
      <MarketingPolicyAgreeModal
        visible={isVisible('MARKETING_POLICY_AGREE')}
        onClose={closeModal}
        onOpenMarketingPolicyComplete={() => setModalState('MARKETING_POLICY_COMPLETE')}
      />
      <MarketingPolicyCompleteModal visible={isVisible('MARKETING_POLICY_COMPLETE')} onClose={closeModal} />
    </>
  );
};

export default EventProfileApplyModal;
